module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/instagram-3145b363464ac924c3edc5be0a47103d.svg";